export default __webpack_public_path__ + "static/media/son_white.4f70742a.svg";